/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2024 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
import * as l from "react";
import { Button as f } from "@progress/kendo-react-buttons";
import { hasMark as u, removeLink as v } from "@progress/kendo-editor-common";
import { onDownPreventDefault as N } from "./utils.mjs";
import { registerForLocalization as b, provideLocalizationService as h } from "@progress/kendo-react-intl";
import { messages as L } from "../messages/index.mjs";
import { classNames as T } from "@progress/kendo-react-common";
var c;
((p) => {
  p.createUnlinkTool = (e) => {
    const a = class extends l.Component {
      render() {
        const { view: o, render: r, ...s } = this.props, n = { mark: e.mark }, d = o ? u(o.state, n) : !1, k = h(this), i = e.messages.title, t = !d, m = /* @__PURE__ */ l.createElement(
          f,
          {
            onClick: t ? void 0 : () => o && v(n, o.state.tr.setMeta("commandName", e.commandName))(o.state, o.dispatch),
            "aria-disabled": t ? !0 : void 0,
            ...N,
            title: k.toLanguageString(i, L[i]),
            ...e.props,
            ...s,
            className: T(s.className, e.props.className, { "k-disabled": t })
          }
        );
        return r ? r.call(void 0, m, { view: o }) : m;
      }
    };
    return b(a), a;
  };
})(c || (c = {}));
export {
  c as UnlinkToolNS
};
